import { useSubmitStudentRequestProgramChangeWithdrawMutation } from '../../../services/graphql/api';
import { getApplDetailParams } from "../../../util/functions";
import MenuDialogBase from "./MenuDialogBase";

export default function DialogStudentRequestApproveProgramChangeWithdrawal({ menuItemAndClose, buttonLabel }) {
  // approve program change / withdrawal
  const [apiCall, result] = useSubmitStudentRequestProgramChangeWithdrawMutation();

  const variablesFn = () => {
    const { applicantEmployeeId, programId, term } = getApplDetailParams();
    return { input: [{ applicantEmployeeId, programId, term }] }
  };

  const buttons = [{ label: buttonLabel, apiCall, result, variablesFn }];
  const extraContent = <></>;

  return (
    <MenuDialogBase menuItemAndClose={menuItemAndClose}
      apiCall={apiCall}
      buttons={buttons}
      result={result}
      extraContent={extraContent}
    />
  );
}